import axios from 'axios'
import router from '@/router/index.js'
import store from '@/store/index.js'


let Api = axios.create({
    baseURL: `https://l0uo7ib742.execute-api.ap-south-1.amazonaws.com/dev/`,
    withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
})

function handle(path, data) {
    return new Promise(function (resolve, reject) {
        Api.post(path, data)
            .then(function (response) {
                if (response.data.ok) {
                    resolve(response.data.result)
                } else {
                    reject(response.data)
                }
            })
            .catch(function (error) {
                console.log('Error :', error.toJSON());
                if (error.response) {
                    reject(error.response.data)
                    if (error.response.status == 401) {
                        store.dispatch('logout')
                        if (router.app.$route.path !== '/login')
                            router.push({ path: '/login' })
                    }
                } else {
                    reject({ "ok": false, "status": null, "description": error.message })
                }
            })
    })
}

export default {
    generate_rzp_order_id(user, tr_data){
        let payload = { user: user, tr_data: tr_data }
        let payload_data = { user: user, method: 'generate_rzp_order_id', data: payload }
        return handle('/payment', payload_data)
    },
    verify_rzp_signature(user, orderCreationId, sign_data){
        let payload = { user: user, order_creation_id: orderCreationId, sign_data: sign_data }
        let payload_data = { user: user, method: 'verify_rzp_signature', data: payload }
        return handle('/payment', payload_data)
    },
}

